import React, { Component } from 'react'
import { connect } from 'react-redux'

import './mytasks.scss'

// Actions
import { getMyTasks, startOtherTask, stopOtherTask, assignUser } from '../../../actions/mypage'
import { triggerPopup } from '../../../actions/backdrop'

// Components
import ActionMenu from '../../../shared/components/ActionMenu'
import MyTasksTask from './Task'
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'
import OtherTaskHover from '../../../shared/components/OthertaskHover'
import TaskOverlay from '../../../shared/overlays/TaskOverlay'

// Utils
import { translation } from '../../../utils/helpers'
import { openOverlay } from '../../../actions/common'

// import { hasSubscriptionPermission } from '../../../utils/auth'
import EventEmitter from '../../../utils/events'
import { renderFullDate } from '../../../utils/time'

// Elements
import Col from '../../../shared/elements/col'
import Icon from '../../../shared/elements/icon'
import PanelHeader from '../../../shared/elements/panelHeader'
import Grid from '../../../shared/elements/grid'
import LabelWrapper from '../../../shared/elements/labelWrapper'

import { ElementIcons } from '../../../shared/elements/icons'
import { hasAccess } from '../../../utils/auth'

class MyTasks extends Component {

  constructor (props) {
    super(props)
    this.state = {
      tasks: {
        CommonTasks: [],
        MyTasks: [],
        UnAssignedTasks: [],
        UnspecifiedTasks: []
      },
      openTask: {
        Show: false,
        Task: null,
        openTaskAsModal: false
      }
    }
    this.startTask = this.startTask.bind(this)
    this.getTasks = this.getTasks.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  componentDidMount () {
    this.getTasks()
    this.checkStartStop(this.props)
    EventEmitter.addListener('UPDATE_TASKS_WORKSCREEN', this.getTasks)
    EventEmitter.addListener('UPDATE_TASKS_MYPAGE', this.getTasks)
  }

  componentWillUnmount () {
    EventEmitter.removeListener('UPDATE_TASKS_WORKSCREEN', this.getTasks)
    EventEmitter.removeListener('UPDATE_TASKS_MYPAGE', this.getTasks)
  }

  componentWillReceiveProps (nextProps) {
    this.checkStartStop(nextProps)
  }

  checkStartStop (props) {
    if (props.occurrenceAction) {
      let { Id, action } = props.occurrenceAction
      if (typeof this.props.handledAction === 'function') this.props.handledAction()
      if (action === 'startStop') {
        setTimeout(() => {
          let orc = document.getElementById('taskId-' + Id)
          if (orc) {
            orc.getElementsByClassName('workers')[0].click()
          }
        }, 1900)
      } else if (action === 'open') {
        setTimeout(() => {
          let orc = document.getElementById('taskId-' + Id)
          if (orc) {
            orc.getElementsByClassName('left')[0].click()
          }
        }, 100)
      }
    }
  }

  getTasks () {
    this.props.getMyTasks(0).then((res) => {
      if (this.props.IsWorkscreen) {
        res.data.MyTasks.map(x => res.data.CommonTasks.push(x))
        res.data.MyTasks = []
        res.data.CommonTasks.sort((a, b) => { return a.Deadline - b.Deadline })
      }
      this.setState({
        tasks: res.data
      })
    }, () => {
      window.toastr.error(translation('2003'), translation('216'))
    })
  }

  renderChild () {
    let child = ''
    if (this.props.children !== null) {
      child = React.cloneElement(this.props.children, {
      })
    }
    return child
  }

  renderTasks () {
    const renderTask = (val, item, key) => {
      const closeConfirm = () => {
        this.setState({
          confirm: {
            showConfirmComplete: false
          }
        })
      }
      const onConfirm = () => {
        closeConfirm()
        this.stopTask(true, this.state.confirm.orcId)
      }
      if (val && typeof val !== 'string') {
        key = item
        item = val
        val = undefined
      }

      let className = ''
      let visited = ''
      let color = ''
      let currentUserWorking = ''
      if (item.IsStarted) className = 'active'
      if (item.MarkYellow) color = 'yellow'
      if (item.IsOverdue) color = 'red'
      if (item.IsCurrentUserWorking) currentUserWorking = 'isWorking '
      // Open task
      const openTask = (task, asmodal = false) => {
        if (this.props.IsWorkscreen && hasAccess([7], this.props.auth.user.UserType)) {
          this.props.onStartAsShopLogin({type: 'task', Id: item.OccurrenceId, action: 'open'})
          return
        }

        if (window.innerWidth <= 760) {
          this.props.triggerPopup(true)
        }
        this.setState({
          openTask: {
            Show: true,
            Task: item,
            openTaskAsModal: asmodal
          }
        }, () => {
          if (this.props.IsWorkscreen || window.innerWidth <= 760) this.props.openOverlay('TaskOverlay')
        })
      }

      // Visited
      if (this.state.openTask && this.state.openTask.Show && item.OccurrenceId === this.state.openTask.Task.OccurrenceId) {
        visited = ' visited'
      }

      // const numOfChars = 60
      const description = item.Description // false && item.Description.length > numOfChars ? (item.Description.substring(0, numOfChars) + '...') : item.Description

      let fileImg = '/images/svgs/workscreen/File.svg'
      if (item.IsStarted) {
        fileImg = '/images/svgs/workscreen/File-white.svg'
      }

      // Return
      return (
        <li key={key} className='clearfix'>
          <div id={'taskId-' + item.OccurrenceId} className='task__item'>
            <Grid cols={[1, 'min-content']} align='center'>
              <div className={'item ' + className}>
                <Grid cols={[1, 'max-content']} align='end'>
                  <div className='left' onClick={openTask.bind(item)}>
                    <OtherTaskHover id={item.OccurrenceId} item={item}>
                      <LabelWrapper labelText={item.Title}>
                        <div className='category'>{translation(item.Category)}</div>
                      </LabelWrapper>
                    </OtherTaskHover>
                    {this.props.IsWorkscreen !== true && <div className='messageBody'>{description}</div>}
                    {this.props.IsWorkscreen && item.HasFiles && <img src={fileImg} className='files' />}
                  </div>
                  <div className='right'>
                    {this.renderStartStop(val, item)}
                    <div className={'deadline ' + currentUserWorking + color}>{item.Deadline ? renderFullDate(item.Deadline, false) : ''}</div>
                  </div>
                </Grid>
              </div>
              {this.props.IsWorkscreen !== true && <Icon icon={ElementIcons.Chevron_Right} onClick={openTask.bind(item)} className={className + visited} />}
            </Grid>
          </div>
          {this.state.confirm && this.state.confirm.showConfirmComplete && this.state.confirm.orcId === item.OccurrenceId &&
            <Portal onPortalClose={closeConfirm}>
              <Confirm
                confirm={onConfirm}
                notConfirm={closeConfirm}
                renderText={() => {
                  return (<div>{translation('15104')}</div>)
                }}
              />
            </Portal>}
        </li>
      )
    }

    return (
      <div className='clearfix'>
        {this.props.IsWorkscreen !== true && [
          <PanelHeader key='1' text={translation('1889')} />,
          <ul key='2'>
            {this.state.tasks.MyTasks.length === 0 ? (
              <div className='no_tasks'>{translation('1226')}</div>) : (
                this.state.tasks.MyTasks.map(renderTask.bind(this, undefined)))}
          </ul>
        ]}
        <PanelHeader text={translation('15088')} />
        <ul>
          {this.state.tasks.CommonTasks.length === 0 ? (
            <div className='no_tasks'>{translation('1226')}</div>) : (
              this.state.tasks.CommonTasks.map(renderTask.bind(this, undefined)))}
        </ul>
        <PanelHeader text={translation('15089')} />
        <ul>
          {this.state.tasks.UnAssignedTasks.length === 0 ? (
            <div className='no_tasks'>{translation('1226')}</div>) : (
              this.state.tasks.UnAssignedTasks.map(renderTask.bind(this, 'assign')))}
        </ul>
        <PanelHeader text={translation('15090')} />
        <ul>
          {this.state.tasks.UnspecifiedTasks.length === 0 ? (
            <div className='no_tasks'>{translation('1226')}</div>) : (
              this.state.tasks.UnspecifiedTasks.map(renderTask.bind(this, 'assign')))}
        </ul>
      </div>
    )
  }

  // Function: start task
  startTask (id) {
    let data = {
      OccurrenceId: id
    }
    this.props.startOtherTask(data).then((res) => {
      if (res.status === 204) {
        window.toastr.error(translation(res.data.DictionaryKey), translation('216'))
      } else {
        if (this.props.IsWorkscreen === true) {
          res.data.MyTasks.map(x => res.data.CommonTasks.push(x))
          res.data.MyTasks = []
          res.data.CommonTasks.sort((a, b) => { return a.Deadline - b.Deadline })
        }
        this.setState({
          tasks: res.data
        })
        this.props.getPunchClockStats() // missing function here!!
      }
    }, () => {
      window.toastr.error(translation('1906'), translation('216'))
    })
  }

  // Function: stop task
  stopTask (FinishTask, id) {
    let data = {
      OccurrenceId: id,
      UserId: 0,
      FinishTask: FinishTask
    }
    this.props.stopOtherTask(data).then((res) => {
      if (res.status === 204) {
        window.toastr.error(translation(res.data.DictionaryKey), translation('216'))
      } else {
        if (this.props.IsWorkscreen === true) {
          res.data.MyTasks.map(x => res.data.CommonTasks.push(x))
          res.data.MyTasks = []
          res.data.CommonTasks.sort((a, b) => { return a.Deadline - b.Deadline })
        }
        this.setState({
          tasks: res.data
        })
      }
    }, () => {
      window.toastr.error(translation('1907'), translation('216'))
    })
  }

  renderStartStop (val, item) {
    if (val && typeof val !== 'string') {
      item = val
      val = undefined
    }

    const initials = () => {
      if (item.Assigns.length > 0) {
        var names = ''
        var init = init = item.Assigns[0].Item1

        if (item.Assigns.length > 1) {
          init += '+'
        }

        item.Assigns.map(x => {
          names += (x.Item2 + '\n')
        })

        return <span className='hint--bottom' aria-label={names}>{init}</span>
      }
    }

    // Return stop task
    if (item.IsCurrentUserWorking) {
      const renderActionOpener = (opener) => {
        return (
          <div className='workers' onClick={opener}>
            <img src={'/images/icons/Ring-White.png'} />
            {initials()}
          </div>
        )
      }
      const renderActionMenu = () => {
        return (
          <div className='poppedup'>
            <a data-action='stop'><img src='/images/icons/Stop-Black.png' />{translation('1224')}</a>
            <a data-action='complete'><img src='/images/icons/Chekmark-Black-32.png' />{translation('1893')}</a>
          </div>
        )
      }
      const handleClick = (el) => {
        switch (el.dataset.action) {
          case 'stop':
            this.stopTask(false, item.OccurrenceId)
            break
          case 'complete':
            this.setState({
              confirm: {
                showConfirmComplete: true,
                orcId: item.OccurrenceId
              }
            })
            break
        }
      }
      return (
        <ActionMenu noAriaLabel className={() => { return 'action__menu close__menu' }} handleClick={handleClick} renderActionOpener={renderActionOpener} renderActionMenu={renderActionMenu} />
      )
    }

    const onClick = (type) => {
      if (this.props.IsWorkscreen && hasAccess([5, 7], this.props.auth.user.UserType)) {
        this.props.onStartAsShopLogin({type: 'task', Id: item.OccurrenceId, action: 'startStop'})
        return false
      }

      if (type === 'assign') {
        this.props.assignUser(item.OccurrenceId).then((res) => {
          if (res.status === 200) {
            if (this.props.IsWorkscreen === true) {
              res.data.MyTasks.map(x => res.data.CommonTasks.push(x))
              res.data.MyTasks = []
              res.data.CommonTasks.sort((a, b) => { return a.Deadline - b.Deadline })
            }
            this.setState({
              tasks: res.data
            })
          }
        }, () => {
          window.toastr.error(translation('1907'), translation('216'))
        })
      } else {
        this.startTask(item.OccurrenceId)
      }
    }

    let circleImg = '/images/icons/Ring-Black.png'
    if (item.IsStarted) {
      circleImg = '/images/icons/Ring-White.png'
    }
    // Return start task
    return (
      <div className='workers' onClick={onClick.bind(val)}>
        <img src={circleImg} />
        {initials()}
      </div>
    )
  }

  onClose () {
    this.props.triggerPopup(false)
    this.setState({
      openTask: {
        Show: false,
        openTaskAsModal: false
      }
    })
  }

  renderTaskPopup () {
    if (this.state.openTask.openTaskAsModal || window.innerWidth <= 760) {
      return (
        <MyTasksTask modal item={this.state.openTask.Task} onClose={this.onClose} />
      )
    }

    return <MyTasksTask item={this.state.openTask.Task} />
  }

  render () {
    if (this.props.IsWorkscreen) {
      return (
        <div>
          {this.renderTasks()}
          {this.state.openTask.Show && (
            <Portal onPortalClose={this.onClose}>
              <TaskOverlay task={this.state.openTask.Task} onClose={this.onClose} />
            </Portal>
            )}
        </div>
      )
    } else {
      return (
        <div className='mytasks__screen'>
          <Col id='items'>
            {this.props.renderMenu()}
            {this.renderTasks()}
          </Col>
          <Col>
            {this.renderChild()}
          </Col>
          {this.state.openTask.Show === true && window.innerWidth > 760 && this.renderTaskPopup()}
          {this.state.openTask.Show && window.innerWidth <= 760 && (<TaskOverlay task={this.state.openTask.Task} onClose={this.onClose} />)}
        </div>
      )
    }
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getMyTasks,
  startOtherTask,
  stopOtherTask,
  triggerPopup,
  openOverlay,
  assignUser
})(MyTasks)



// WEBPACK FOOTER //
// ./src/app/pages/MyPage/MyTasks/index.js